import { FileText, Hash, HardDrive, TrendingDown } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function PDFAnalyzer({ analysis }) {
  const { lang } = useLanguage();
  if (!analysis) return null;

  const labels = {
    en: {
      title: "File Analysis",
      pages: "Pages",
      size: "File size",
      type: "Content type",
      compress: "Compression potential",
      text: "Text",
      images: "Images",
      mixed: "Mixed",
    },
    fr: {
      title: "Analyse du fichier",
      pages: "Pages",
      size: "Taille",
      type: "Type de contenu",
      compress: "Potentiel de compression",
      text: "Texte",
      images: "Images",
      mixed: "Mixte",
    },
  };
  const L = labels[lang] || labels.en;

  const contentTypeLabel = {
    text: L.text,
    images: L.images,
    mixed: L.mixed,
  }[analysis.content_type] || L.mixed;

  return (
    <div
      className="mt-4 p-4 rounded-xl bg-blue-50 border border-blue-100"
      data-testid="pdf-analyzer"
    >
      <p className="text-xs font-semibold text-blue-700 uppercase tracking-wider mb-3">{L.title}</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="flex items-center gap-2">
          <Hash className="w-4 h-4 text-blue-500 flex-shrink-0" />
          <div>
            <p className="text-xs text-slate-500">{L.pages}</p>
            <p className="text-sm font-semibold text-slate-800">{analysis.page_count}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <HardDrive className="w-4 h-4 text-blue-500 flex-shrink-0" />
          <div>
            <p className="text-xs text-slate-500">{L.size}</p>
            <p className="text-sm font-semibold text-slate-800">{analysis.size_mb} MB</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <FileText className="w-4 h-4 text-blue-500 flex-shrink-0" />
          <div>
            <p className="text-xs text-slate-500">{L.type}</p>
            <p className="text-sm font-semibold text-slate-800">{contentTypeLabel}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <TrendingDown className="w-4 h-4 text-green-500 flex-shrink-0" />
          <div>
            <p className="text-xs text-slate-500">{L.compress}</p>
            <p className="text-sm font-semibold text-green-700">~{analysis.compression_estimate}%</p>
          </div>
        </div>
      </div>
    </div>
  );
}
